import initHeader from "./components/header";
import initHomeServices from "./components/home-services";
import initLeafletMaps from "./components/maps/maps";
import initProjectFilters from "./components/project-filtes";
import initProjectLightbox from "./components/project-lightbox";
initHeader();
initHomeServices();
initProjectLightbox();
initProjectFilters();
initLeafletMaps();
